import { useEffect, useState } from "react";
import { addPCCComment, fetchPCCComents } from "../../apis/pccApi";
import { message, Input } from "antd";
import moment from "moment";
const { TextArea } = Input;

const PCCComments = ({ pqrId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const loadComments = async () => {
    try {
      const res = await fetchPCCComents(pqrId);
      setComments(res.data);
    } catch {
      message.error("Error al cargar los comentarios");
    }
  };

  useEffect(() => {
    loadComments();
  }, [pqrId]);

  const handleAddComment = async () => {
    try {
      await addPCCComment(pqrId, newComment);
      setNewComment("");
      await loadComments();
    } catch {
      message.error("Error al agregar comentario");
    }
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">Comments</h5>
        {comments.map((c) => (
          <div key={c.id} className="border-bottom py-2">
            <p className="mb-1">{c.comment}</p>
            <small className="text-muted">
              By {c.commenter_name} at {moment(c.created_at).utc().format("DD/MM/YYYY HH:mm")}
            </small>
          </div>
        ))}
        <TextArea
          className="form-control mt-3"
          autoSize={{ minRows: 3, maxRows: 12 }}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Agrega un comentario..."
        />
        <button className="btn btn-primary mt-2" onClick={handleAddComment}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default PCCComments;
